import { Button } from "@/components/ui/button";
import { noop } from "lodash";
import { useState } from "react";
import { useTranslation } from "react-i18next";

type Props = {
  onDisconnect: () => Promise<void>;
};

export const DisconnectButton = ({ onDisconnect }: Props) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const handleDisconnect = async () => {
    setLoading(true);
    try {
      onDisconnect();
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      variant="outline"
      className="self-end"
      onClick={handleDisconnect}
      disabled={loading}
    >
      {t("integrations.kanzleiland.disconnect")}
    </Button>
  );
};
